import { Component } from '@theme/component';

/**
 * A custom element that formats rte content for easier styling
 */
class RTEFormatter extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.querySelectorAll('table').forEach(this.#formatTable);
  }

  /**
   * Formats a table for easier styling
   * @param {HTMLTableElement} table
   */
  #formatTable(table) {
    const parent = table.parentElement;
    if (!parent) return;
    const wrapper = parent.classList.contains('rte-table-wrapper') ? parent : document.createElement('div');
    if (wrapper !== parent) {
      wrapper.classList.add('rte-table-wrapper');
      parent.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    }
    wrapper.tabIndex = 0;
    const label = table.caption?.textContent?.trim() || table.getAttribute('aria-label');
    if (label) {
      wrapper.setAttribute('role', 'region');
      wrapper.setAttribute('aria-label', label);
    }
  }
}

if (!customElements.get('rte-formatter')) {
  customElements.define('rte-formatter', RTEFormatter);
}

